<template>
  <div>
    <!-- Settings -->
    <b-card
      no-body
      class="mb-1"
    >
      <b-card-header class="p-1">
        <b-card-title class="font-medium-2 mb-0">
          <feather-icon
            icon="GitBranchIcon"
            size="18"
            class="mr-50"
          />
          Сравнение сценариев
        </b-card-title>
      </b-card-header>
      <b-card-body class="pt-1 pb-1">
        <!-- Object + Scenario entity -->
        <b-row class="mb-1">
          <b-col md="4">
            <b-form-group
              label="Объект"
              label-for="obj-select"
            >
              <v-select
                id="obj-select"
                v-model="selectedObj"
                label="title"
                :options="objList"
                :loading="loadingObjList"
                :filter-by="filterBy"
                placeholder="Поиск объекта по имени..."
                @input="onSelectObj"
              >
                <template #option="{ title, sid }">
                  {{ title }}
                  <small class="text-muted">({{ sid }})</small>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Поле группировки (показатель)"
              label-for="group-entity"
            >
              <b-form-select
                id="group-entity"
                v-model="groupEntitySid"
                :options="allColumnsOptions"
                :disabled="!objFull"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Поле для сравнения (суммирование)"
              label-for="value-entity"
            >
              <b-form-select
                id="value-entity"
                v-model="valueEntitySid"
                :options="numericColumnsOptions"
                :disabled="!objFull"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Scenarios -->
        <b-row class="mb-1">
          <b-col md="4">
            <b-form-group
              label="Сущность сценария (SID)"
              label-for="scn-entity"
            >
              <b-form-input
                id="scn-entity"
                v-model="scenarioEntitySid"
                placeholder="scenario"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Сценарий 1"
              label-for="scn1"
            >
              <b-form-select
                id="scn1"
                v-model="scn1Id"
                :options="scenarioOptions"
                :disabled="!qryScenarios"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Сценарий 2"
              label-for="scn2"
            >
              <b-form-select
                id="scn2"
                v-model="scn2Id"
                :options="scenarioOptions"
                :disabled="!qryScenarios"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Filters -->
        <b-row class="mb-1">
          <!-- Filter Scenario 1 -->
          <b-col md="6">
            <div class="border rounded p-1">
              <div class="d-flex justify-content-between align-items-center mb-50">
                <small class="font-weight-bold text-primary">Фильтр — Сценарий 1</small>
                <b-button
                  size="sm"
                  variant="outline-success"
                  :disabled="!objFull"
                  @click="addFilter(1)"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="12"
                  /> Условие
                </b-button>
              </div>
              <div
                v-for="(cond, idx) in filters1"
                :key="`f1_${idx}`"
                class="d-flex align-items-center mb-25"
              >
                <b-form-select
                  v-model="cond.entitySid"
                  :options="allColumnsOptions"
                  size="sm"
                  class="mr-25"
                  style="min-width:120px"
                />
                <b-form-select
                  v-model="cond.oper"
                  :options="operOptions"
                  size="sm"
                  class="mr-25"
                  style="min-width:110px"
                />
                <b-form-input
                  v-model="cond.value"
                  size="sm"
                  placeholder="Значение"
                  class="mr-25"
                />
                <b-button
                  size="sm"
                  variant="flat-danger"
                  @click="removeFilter(1, idx)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="12"
                  />
                </b-button>
              </div>
              <small
                v-if="!filters1.length"
                class="text-muted"
              >Без дополнительных условий</small>
            </div>
          </b-col>

          <!-- Filter Scenario 2 -->
          <b-col md="6">
            <div class="border rounded p-1">
              <div class="d-flex justify-content-between align-items-center mb-50">
                <small class="font-weight-bold text-primary">Фильтр — Сценарий 2</small>
                <b-button
                  size="sm"
                  variant="outline-success"
                  :disabled="!objFull"
                  @click="addFilter(2)"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="12"
                  /> Условие
                </b-button>
              </div>
              <div
                v-for="(cond, idx) in filters2"
                :key="`f2_${idx}`"
                class="d-flex align-items-center mb-25"
              >
                <b-form-select
                  v-model="cond.entitySid"
                  :options="allColumnsOptions"
                  size="sm"
                  class="mr-25"
                  style="min-width:120px"
                />
                <b-form-select
                  v-model="cond.oper"
                  :options="operOptions"
                  size="sm"
                  class="mr-25"
                  style="min-width:110px"
                />
                <b-form-input
                  v-model="cond.value"
                  size="sm"
                  placeholder="Значение"
                  class="mr-25"
                />
                <b-button
                  size="sm"
                  variant="flat-danger"
                  @click="removeFilter(2, idx)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="12"
                  />
                </b-button>
              </div>
              <small
                v-if="!filters2.length"
                class="text-muted"
              >Без дополнительных условий</small>
            </div>
          </b-col>
        </b-row>

        <!-- Compare button -->
        <div class="d-flex align-items-center">
          <b-button
            variant="primary"
            :disabled="!canCompare || loading"
            @click="compare"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-50"
            />
            <feather-icon
              v-else
              icon="BarChart2Icon"
              size="14"
              class="mr-50"
            />
            Сравнить
          </b-button>
          <b-button
            v-if="tableRows.length"
            variant="flat-secondary"
            class="ml-1"
            @click="clearResults"
          >
            <feather-icon
              icon="XCircleIcon"
              size="14"
              class="mr-25"
            />
            Очистить
          </b-button>
        </div>
      </b-card-body>
    </b-card>

    <!-- Results table -->
    <b-card
      v-if="tableRows.length"
      no-body
    >
      <b-card-header class="p-1">
        <b-card-title class="font-medium-2 mb-0">
          Результаты сравнения
        </b-card-title>
        <div class="d-flex align-items-center">
          <small class="text-muted mr-1">{{ scnName(scn1Id) }} vs {{ scnName(scn2Id) }}</small>
        </div>
      </b-card-header>
      <b-table
        :items="tableRows"
        :fields="tableFields"
        small
        bordered
        responsive
        class="mb-0"
        :tbody-tr-class="rowClass"
      >
        <template #cell(val1)="{ item }">
          <span :class="{ 'font-weight-bold': item.isTotal }">
            {{ formatNum(item.val1) }}
          </span>
        </template>
        <template #cell(val2)="{ item }">
          <span :class="{ 'font-weight-bold': item.isTotal }">
            {{ formatNum(item.val2) }}
          </span>
        </template>
        <template #cell(absDev)="{ item }">
          <span :class="[absDev_class(item.absDev), { 'font-weight-bold': item.isTotal }]">
            {{ formatNum(item.absDev, true) }}
          </span>
        </template>
        <template #cell(relDev)="{ item }">
          <span :class="absDev_class(item.relDev)">
            {{ item.relDev !== null ? item.relDev.toFixed(2) + '%' : '—' }}
          </span>
        </template>
        <template #cell(indicator)="{ item }">
          <span :class="{ 'font-weight-bold': item.isTotal }">
            {{ item.indicator }}
          </span>
        </template>
      </b-table>
    </b-card>

    <cbs-debug
      v-if="isRoot"
      :context="this"
    />
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
  BRow, BCol, BFormGroup, BFormInput, BFormSelect,
  BButton, BTable, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import useCubus from '@/cubus/services/useCubus'

const NUMERIC_TYPES = ['double', 'int', 'decimal', 'money', 'integer', 'float', 'number', 'numeric', 'bigdecimal']

export default {
  name: 'CbsScenarioCompare',

  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BSpinner,
    vSelect,
    CbsDebug,
  },

  props: {
    objectFull: {
      type: Object,
      default: null,
    },
  },

  setup() {
    return { isRoot: useCubus.isRoot() }
  },

  data() {
    return {
      selectedObj: null,
      objList: [],
      loadingObjList: false,
      objFull: null,

      qryScenarios: null,

      scn1Id: null,
      scn2Id: null,
      scenarioEntitySid: 'scenario',
      groupEntitySid: null,
      valueEntitySid: null,

      filters1: [],
      filters2: [],

      loading: false,
      tableRows: [],

      operOptions: [
        { value: 'equal', text: '=' },
        { value: 'notequal', text: '≠' },
        { value: 'greater', text: '>' },
        { value: 'greaterorequal', text: '>=' },
        { value: 'less', text: '<' },
        { value: 'lessorequal', text: '<=' },
        { value: 'contains', text: 'содержит' },
      ],
    }
  },

  computed: {
    attributes() {
      return this.objFull?.attributes || []
    },

    allColumnsOptions() {
      const attrs = this.attributes
      if (!attrs.length) return [{ value: null, text: '— не выбрано —' }]
      return [
        { value: null, text: '— не выбрано —' },
        ...attrs.map(a => ({ value: a.entitysid, text: a.label || a.entitysid })),
      ]
    },

    numericColumnsOptions() {
      const attrs = this.attributes
      if (!attrs.length) return [{ value: null, text: '— не выбрано —' }]
      const numeric = attrs.filter(a => NUMERIC_TYPES.includes((a.datatype || a.datatypesid || '').toLowerCase()))
      const list = numeric.length ? numeric : attrs
      return [
        { value: null, text: '— не выбрано —' },
        ...list.map(a => ({ value: a.entitysid, text: a.label || a.entitysid })),
      ]
    },

    scenarioOptions() {
      if (!this.qryScenarios) return [{ value: null, text: 'Загрузка...' }]
      return [
        { value: null, text: '— не выбрано —' },
        ...this.qryScenarios.recordset.records.map(r => ({
          value: r.id?.value ?? r[Object.keys(r)[0]]?.value,
          text: r.name?.value || r.title?.value || String(r.id?.value),
        })),
      ]
    },

    tableFields() {
      return [
        {
          key: 'indicator', label: 'Показатель', sortable: true, thStyle: { minWidth: '180px' },
        },
        {
          key: 'val1', label: this.scnName(this.scn1Id), sortable: true, thClass: 'text-right', tdClass: 'text-right',
        },
        {
          key: 'val2', label: this.scnName(this.scn2Id), sortable: true, thClass: 'text-right', tdClass: 'text-right',
        },
        {
          key: 'absDev', label: 'Абс. отклонение', sortable: true, thClass: 'text-right', tdClass: 'text-right',
        },
        {
          key: 'relDev', label: 'Отн. отклонение', sortable: true, thClass: 'text-right', tdClass: 'text-right',
        },
      ]
    },

    canCompare() {
      return this.selectedObj?.value && this.objFull && this.scn1Id && this.scn2Id && this.groupEntitySid && this.valueEntitySid
    },
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      const p = this.getParam
      this.scenarioEntitySid = p('scenario_compare_scn_entity', 'scenario')
      this.groupEntitySid = p('scenario_compare_group_entity', null)
      this.valueEntitySid = p('scenario_compare_value_entity', null)

      this.loadScenarios()
      this.loadObjList()
    },

    getParam(name, defaultValue = null) {
      const params = this.objectFull?.params?.params
      if (!params) return defaultValue
      const prm = params.find(p => p.paramname === name)
      return prm ? prm.paramvalue : defaultValue
    },

    async loadScenarios() {
      this.qryScenarios = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'scenario',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [useCubus.cond_notDel()],
          },
        },
        orderby: useCubus.orderbyName(),
        pageSize: 10000,
      })
    },

    async loadObjList() {
      this.loadingObjList = true
      try {
        const qry = await useCubus.loadQuery(this, {
          keymode: 'sid',
          objectsid: 'object',
          filter: {
            isactive: true,
            node: {
              isactive: true,
              oper: { sid: 'and' },
              nodes: [],
              conds: [useCubus.cond_notDel()],
            },
          },
          orderby: useCubus.orderbyName(),
          pageSize: useCubus.LOAD_ALL,
        })
        if (qry) {
          this.objList = qry.recordset.records.map(r => ({
            value: r.id?.value,
            title: r.name?.value || r.sid?.value || String(r.id?.value),
            sid: r.sid?.value,
          }))
        }
      } finally {
        this.loadingObjList = false
      }
    },

    onSelectObj() {
      this.objFull = null
      this.groupEntitySid = null
      this.valueEntitySid = null
      this.tableRows = []
      if (this.selectedObj?.value) this.loadObjDef()
    },

    async loadObjDef() {
      if (!this.selectedObj?.value) return
      this.objFull = await useCubus.loadObject(this, { objectid: this.selectedObj.value })
      const p = this.getParam
      this.groupEntitySid = p('scenario_compare_group_entity', null)
      this.valueEntitySid = p('scenario_compare_value_entity', null)
    },

    buildFilter(scnId, extraConds) {
      const conds = [
        useCubus.cond_notDel(),
        {
          isactive: true,
          oper: { sid: 'equal' },
          args: [
            { type: { sid: 'entitysid' }, value: this.scenarioEntitySid },
            { type: { sid: 'value' }, value: scnId },
          ],
        },
        ...extraConds.map(c => ({
          isactive: true,
          oper: { sid: c.oper },
          args: [
            { type: { sid: 'entitysid' }, value: c.entitySid },
            { type: { sid: 'value' }, value: c.value },
          ],
        })).filter(c => c.args[0].value && c.args[1].value !== ''),
      ]
      return {
        isactive: true,
        node: {
          isactive: true,
          oper: { sid: 'and' },
          nodes: [],
          conds,
        },
      }
    },

    async compare() {
      if (!this.canCompare) return
      this.loading = true
      this.tableRows = []
      try {
        const baseParams = {
          keymode: 'sid',
          objectid: this.selectedObj.value,
          groupby: {
            isActive: true,
            groups: [
              {
                isActive: true,
                oper: { sid: 'group' },
                entity: { sid: this.groupEntitySid },
              },
              {
                isActive: true,
                oper: { sid: 'sum' },
                entity: { sid: this.valueEntitySid },
              },
            ],
          },
          pageSize: useCubus.LOAD_ALL,
        }

        const [q1, q2] = await Promise.all([
          useCubus.loadQuery(this, { ...baseParams, filter: this.buildFilter(this.scn1Id, this.filters1) }),
          useCubus.loadQuery(this, { ...baseParams, filter: this.buildFilter(this.scn2Id, this.filters2) }),
        ])

        if (q1 && q2) {
          this.tableRows = this.mergeResults(q1, q2)
        }
      } finally {
        this.loading = false
      }
    },

    mergeResults(q1, q2) {
      const groupKey = this.groupEntitySid
      const valueKey = this.valueEntitySid

      const map = new Map()

      const getValue = rec => parseFloat(rec[valueKey]?.value ?? 0) || 0
      const getIndicator = rec => rec[groupKey]?.title || rec[groupKey]?.value || '—'
      const getKey = rec => String(rec[groupKey]?.value ?? '—')

      q1.recordset.records.forEach(rec => {
        const key = getKey(rec)
        map.set(key, {
          indicatorKey: key,
          indicator: getIndicator(rec),
          val1: getValue(rec),
          val2: 0,
        })
      })

      q2.recordset.records.forEach(rec => {
        const key = getKey(rec)
        if (map.has(key)) {
          map.get(key).val2 = getValue(rec)
        } else {
          map.set(key, {
            indicatorKey: key,
            indicator: getIndicator(rec),
            val1: 0,
            val2: getValue(rec),
          })
        }
      })

      const rows = Array.from(map.values()).map(row => ({
        ...row,
        absDev: row.val2 - row.val1,
        relDev: row.val1 !== 0 ? ((row.val2 - row.val1) / Math.abs(row.val1)) * 100 : null,
        isTotal: false,
      }))

      const totalVal1 = rows.reduce((s, r) => s + r.val1, 0)
      const totalVal2 = rows.reduce((s, r) => s + r.val2, 0)
      const totalAbsDev = totalVal2 - totalVal1
      rows.push({
        indicator: 'ИТОГО',
        val1: totalVal1,
        val2: totalVal2,
        absDev: totalAbsDev,
        relDev: totalVal1 !== 0 ? (totalAbsDev / Math.abs(totalVal1)) * 100 : null,
        isTotal: true,
      })

      return rows
    },

    clearResults() {
      this.tableRows = []
    },

    addFilter(num) {
      const cond = { entitySid: null, oper: 'equal', value: '' }
      if (num === 1) this.filters1.push(cond)
      else this.filters2.push(cond)
    },

    removeFilter(num, idx) {
      if (num === 1) this.filters1.splice(idx, 1)
      else this.filters2.splice(idx, 1)
    },

    scnName(id) {
      if (!id || !this.qryScenarios) return id ? String(id) : '—'
      const rec = this.qryScenarios.recordset.records.find(r => r.id?.value === id)
      return rec ? (rec.name?.value || rec.title?.value || String(id)) : String(id)
    },

    formatNum(val, showSign = false) {
      if (val === null || val === undefined) return '—'
      const n = parseFloat(val)
      if (Number.isNaN(n)) return '—'
      const formatted = useCubus.formatNumber(n, { precision: 2 })
      return showSign && n > 0 ? `+${formatted}` : formatted
    },

    absDev_class(val) {
      if (val === null || val === undefined) return ''
      if (val > 0) return 'text-success'
      if (val < 0) return 'text-danger'
      return ''
    },

    rowClass(item) {
      if (!item) return ''
      return item.isTotal ? 'table-active font-weight-bold' : ''
    },

    filterBy(option, label, search) {
      const pattern = `.*${search.replace(/ /gi, '.*')}.*`
      return new RegExp(pattern, 'gi').test(label || '')
    },
  },
}
</script>
